export default __webpack_public_path__ + "static/media/MP5_2.52bde61b.png";